<template>
  <div class="inline-block">
    <div class="ui-avatar" :class="`ui-avatar--${size}`">
      <div class="ui-avatar-inner w-full text-center leading-none">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  color?: 'primary';
  size?: 'sm' | 'md';
}

withDefaults(defineProps<Props>(), {
  color: 'primary',
  size: 'md',
});
</script>

<style scoped lang="scss">
.ui-avatar {
  --ui-avatar-color: rgb(var(--v-theme-primary, 25, 118, 210));
  --ui-avatar-text-color: theme('colors.white');
  --ui-avatar-size: 2em;
  --ui-avatar-font-size: 1em;

  width: var(--ui-avatar-size);
  height: var(--ui-avatar-size);
  line-height: 0;
  background-color: var(--ui-avatar-color);
  color: var(--ui-avatar-text-color);
  border-radius: 9999em;
  text-transform: uppercase;
  min-width: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 2px solid var(--ui-avatar-color);
}

.ui-avatar--md {
  --ui-avatar-size: 2em;
  --ui-avatar-font-size: 1em;
}

.ui-avatar--sm {
  --ui-avatar-size: 1.5em;
  --ui-avatar-font-size: 0.75em;
}

.ui-avatar-inner {
  min-width: 0;
  font-weight: 500;
  font-size: var(--ui-avatar-font-size);
  letter-spacing: 0;
  line-height: 1;
  overflow: hidden;
  width: 100%;
  text-wrap: none;
  white-space: nowrap;
}
</style>
